import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReviewsResponse } from './reviews.model';

export const selectInstructorReviewsState = createFeatureSelector<ReviewsResponse>('instructorReviews');

export const selectInstructorReviews = createSelector(selectInstructorReviewsState, (entities) => entities);
